import React, { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import Start from '../forms/Start';
import SelectVehicle from '../components/SelectVehicle';
import TooltipInfo from '../components/TooltipInfo';
import { getVehicles } from '../api';
import { actionTypes as appActionTypes, selectors as appSelectors } from '../features/app'
import { selectors as dealerSelectors } from '../features/dealer'
import { selectors as errorSelectors } from '../features/error'
import { actionTypes as errorActionTypes } from '../features/error'
import { IError, IErrorButton } from '../features/error/types'
import { AnalyticElement, baseName, IAnalyticEvent, IVehicleResult, Routes } from '../types.d';
import { SET_APP } from '../features/app/actionTypes';
import { scrollToBeginning } from '../helpers'
import { SendEvent } from '../analytics'

export const Specs: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector(appSelectors.getAppIsLoading);
  const isError = useSelector(errorSelectors.getErrorTitle);
  const step = useSelector(appSelectors.getAppStep);
  const locationName = useSelector(dealerSelectors.getDealerLocationName);
  const [vehicles, setVehicles] = useState<IVehicleResult[]>([]);
  const [isInit, setIsInit] = useState(false);
  const [isTooOld, setIsTooOld] = useState(false);

  const handleAnalyticEvent = (evt: IAnalyticEvent) => {
    switch (evt.element){
      case AnalyticElement.Button:
        SendEvent({
          event: 'sendEvent',
          eventCategory: 'User Interactions',
          eventAction: `Instant Offer - specs form`,
          eventLabel: `Continue - button click`,
          eventValue: 0,
          nonInteraction: false
        });
        break;
    }
  }
  const handleStartSubmit = (rego: string, state: string, captcha: string) => {
    SendEvent({
      event: 'formSubmit',
      formName: 'specs'
    });
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: true } });
    getVehicleResults(rego, state, captcha);
  }
  const getVehicleResults = async (rego: string, state: string, captcha: string) => {
    const r = await getVehicles(rego, state, captcha);
    if (!r.errormessage && r.result){
      setVehicles(r.result);
      dispatch({ type: appActionTypes.SET_APP, payload: { subStep: 1 } });
      SendEvent({
        event: 'sendVirtualPageView',
        pageType: 'instantoffer',
        viewSection: 'selectVehicle',
        viewName: 'specs',
      });
    }
    else if (r.errormessage != 'VEHICLE OVER TEN YEARS OLD') {
      const btns: Array<IErrorButton> = [
        {
          title: 'Back to registration', 
          classes: 'button-solid', 
          callback: () => { location.pathname = baseName + Routes.Specs }, 
          clearErrorOnClick: false
        }
      ]
      const err: IError = { 
        icon: require('../assets/images/barricade.svg'),
        title: 'NOT FOUND FOR REGO/STATE' == r.errormessage ? 'Sorry, we couldn’t find a match.' : 'Sorry, we seem to be experiencing some technical difficulties, please try again later.',
        buttons: btns
      };
      dispatch({ type: errorActionTypes.SET_ERROR, payload: err });
    }
    else {
      setIsTooOld(true);
    }
    dispatch({ type: appActionTypes.SET_APP, payload: { isLoading: false } });
    scrollToBeginning();
  };
  const handleVehicleSelect = () => {
    SendEvent({
      event: 'sendEvent',
      eventCategory: 'User Interactions',
      eventAction: `Instant Offer - select vehicle`,
      eventLabel: `This is my vehicle - button click`,
      eventValue: 0,
      nonInteraction: false
    });
    dispatch({type: SET_APP, payload: { isLoading: true }});
    history.push(Routes.Condition);
  }
  const onVehicleClear = () => {
    setVehicles([]);
    dispatch({ type: appActionTypes.SET_APP, payload: { subStep: 0 } });
    SendEvent({
      event: 'sendEvent',
      eventCategory: 'User Interactions',
      eventAction: `Instant Offer - select vehicle`,
      eventLabel: `This isn't my car - button click`,
      eventValue: 0,
      nonInteraction: false
    })
    SendEvent({
      event: 'sendVirtualPageView',
      pageType: 'instantoffer',
      viewSection: 'form',
      viewName: 'specs',
    });
  };
  const handleBackToRegoClick = () => {
    setIsTooOld(false);
  };
  const handleDealerClick = () => {
    location.pathname = '/';
  };
  useEffect(() => {
    if (!isInit){
      setIsInit(true);
      dispatch({type: SET_APP, payload: { step: 0, subStep: 0, isLoading: false }});
      SendEvent({
          event: 'sendVirtualPageView',
          pageType: 'instantoffer',
          viewSection: 'form',
          viewName: 'specs',
      });
    }
  });

  return (
    <Fragment>
      {!isTooOld && !vehicles.length ? 
        <section className={`i-step-start i-step-all ${isLoading || isError ? 'i-loading' : ''}`}>
          <div className="i-con">
            <div className="i-row i-step-all-row">
              <div className="i-col">
                  <h2>
                    Let’s start with your car’s rego and total kilometres&nbsp;
                    <TooltipInfo title={<React.Fragment>
                      <p><strong>What does rego mean?</strong></p><p>Your Vehicle Registration (rego) is a legal document that identifies your vehicle. It is mandatory to have a valid rego to drive a vehicle in Australia.</p>
                    </React.Fragment>} />
                  </h2>
              </div>
              <div className="i-col">
                {step == 0 && <Start handleAnalyticEvent={handleAnalyticEvent} handleStartSubmit={handleStartSubmit} />}
              </div>
            </div>
          </div>
        </section>
      : !isTooOld ? <SelectVehicle vehicles={vehicles} onSelect={handleVehicleSelect} onClear={onVehicleClear} />
      : <section className="i-step-too-old">
          <div className="i-con">
            <h2>Unfortunately, your vehicle is over 10 years old</h2>
            <p>Your car must be less than 10 years old and have completed less than 200,000km to be eligible for a&nbsp;valuation.</p>
            <div className="i-button-group">
              <button className="button-outline" onClick={handleBackToRegoClick}>Back to Rego</button>
              <button className="button-solid" onClick={handleDealerClick}>Back to {locationName}</button>
            </div>
          </div>
        </section>}
    </Fragment>
  )
}
